
import { mapGetters } from 'vuex';
import IDateRange from '@/../types/custom';
import CommissionAttendantsGraphic from "@/components/CommissionAttendantsGraphic.vue";
import LayoutDefault from "@/components/layout/default/LayoutDefault.vue";
import TabulationsShareGraphic from "@/components/TabulationsShareGraphic.vue";
import ActionService from "@/services/lead/ActionService";
import leadService from "@/services/leadService";
import saasService from "@/services/SaasService";
import moment from "moment";
import { Component, Vue } from "vue-property-decorator";
import vSelect from "vue-select";
import DateRangePicker from "vue2-daterange-picker";
import WidgetCsat from '@/components/widget/WidgetCsat.vue';

@Component({
  components: {
    LayoutDefault,
    DateRangePicker,
    vSelect,
    CommissionAttendantsGraphic,
    TabulationsShareGraphic,
    WidgetCsat
  },

  computed: {
    ...mapGetters('auth', ['allowedFeature'])
  }
})
export default class Dashboard extends Vue {

  private leadServiceInstance = new leadService();
  private actionServiceInstance = new ActionService();
  private saasServiceInstance = new saasService();

  private metrics: {funnel: any, secondary: any} = {funnel:{}, secondary: {}};
  private metricsUser: {funnel: any, secondary: any} = {funnel:{}, secondary: {}};
  private actions: any = [];
  private pluginOption: any = [];
  private pluginSelected: any = '';
  private actionSelected?: number[] = [];
  private actionSelectedLoaded?: number | number[] = 0;

  private panels: any[] = [
    {name: 'Visão geral por grupo de leads recebidos', image: 'icon-funnel', showFunnel: 1},
    {name: 'Visão geral por período', image: 'icon-grid', showFunnel: 0}
  ];

  private selectedPanel: any = this.panels[0];

  private selectPanel(panel: any) {
    this.selectedPanel = panel;
    this.getMetrics();
  }

  // image in dropdown button does not render if not called like this
  getImage(img: any) {
    let images = require.context('../assets/img/', false, /\.svg$/)
    return images('./' + img + ".svg")
  }

  private get loading() {
    return !this.loadingMetric && !this.loadingAction ? false : true;
  }

  private get loadingPlugin() {
    return !(this.pluginOption && this.pluginOption.length > 0);
  }

  private loadingMetric: boolean = false;
  private loadingAction: boolean = false;

  private containsInSubMetrics(subMetrics: any, valueToFind: string) {
    let flag: boolean = false;
    if (!!subMetrics) {
      for (let obj in subMetrics) {
        if (subMetrics[obj].name === valueToFind) {
          flag = true
          break
        }
      }
    }
    return flag
  }

  private hideTotalConversions() {
    let existsTotalConversions = this.containsInSubMetrics(this.metrics.secondary, 'total_conversions')
    return this.selectedPanel.showFunnel === 1 && existsTotalConversions
  }

  private dateRange: IDateRange = {
    startDate: "",
    endDate: ""
  };

  private dateRangeLoaded: IDateRange = {
    startDate: "",
    endDate: ""
  };

  private topTerms: any = {};
  private sentiment: any = {};

  private clearFilter() {
    this.dateRange.startDate = this.$moment().format("YYYY/MM/DD");
    this.dateRange.endDate = this.$moment().format("YYYY/MM/DD");
    this.dateRangeLoaded.startDate = this.dateRange.startDate;
    this.dateRangeLoaded.endDate = this.dateRange.endDate;
    this.actionSelected = [];
    this.pluginOption = null;
    this.pluginSelected = '';
    this.getMetrics();
    this.actionSelectedLoaded = this.actionSelected;
    this.$bvModal.hide("modal-filter");
  }

  private getMinLimitDay(){
    return this.$moment('2022-07-01', 'YYYY-MM-DD').format('YYYY-MM-DD')
  }

  private getToday(){
    return this.$moment().format('YYYY-MM-DD')
  }

  private sendFilter() {
    this.getMetrics();

    this.$bvModal.hide("modal-filter");
  }

  private openFilter() {
    this.getPluginByAction();
    this.$bvModal.show("modal-filter");
  }

  private dateFormat(picker: any) {
    let result = "Filtro por data";
    if (picker.startDate) {
      result = String(
        (this.$moment(picker.startDate) as any).format("DD [de] MMM.")
      );
      picker.endDate = picker.endDate ? picker.endDate : picker.startDate;
      result +=
        " - " +
        String((this.$moment(picker.endDate) as any).format("DD [de] MMM. [de] YYYY"));
    }
    return result;
  }

  private async getMetrics() {
    this.loadingMetric = true;
    let filterDate: Array<any> = ["", ""];
    if (this.dateRange.startDate)
      filterDate[0] =
        (this.$moment(this.dateRange.startDate) as any).format("YYYY-MM-DD") +
        " 00:00:00";
      filterDate[0] = this.$moment(filterDate[0], "YYYY-MM-DD");
      filterDate[0] = this.$moment
        .utc(filterDate[0])
        .format("YYYY-MM-DD");

    if (this.dateRange.endDate)
      filterDate[1] =
        (this.$moment(this.dateRange.endDate) as any).format("YYYY-MM-DD") +
        " 24:00:00";
      filterDate[1] = this.$moment(filterDate[1], "YYYY-MM-DD");
      filterDate[1] = this.$moment
        .utc(filterDate[1])
        .format("YYYY-MM-DD");

    this.metrics = {funnel:{}, secondary: {}};
    this.metricsUser = {funnel:{}, secondary: {}};

    await this.leadServiceInstance
      .metricsPlatform().then(async (result: any) => {
        this.actionSelectedLoaded = this.actionSelected;
        this.dateRangeLoaded.startDate = this.dateRange.startDate;
        this.dateRangeLoaded.endDate = this.dateRange.endDate;

        for (const metric of result.metrics) {
          const showFunnel = this.selectedPanel.showFunnel ? true : false;

          await this.leadServiceInstance
          .metrics(
            this.actionSelected ? this.actionSelected : [],
            filterDate[0],
            filterDate[1],
            metric.name,
            this.pluginSelected ? this.pluginSelected.plugin : '' as string,
            showFunnel
          ).then((result: any) => {
            if (metric.type === 'funnel' || metric.type === null){
                this.$set(this.metrics.funnel, metric.order_metric, {...metric, ...result})
            } else {
                this.$set(this.metrics.secondary, metric.order_metric, {...metric, ...result})
            }

            this.actionSelectedLoaded = this.actionSelected;

            this.dateRangeLoaded.startDate = this.dateRange.startDate;
            this.dateRangeLoaded.endDate = this.dateRange.endDate;
          });

           if(['total_leads_worked', 'total_leads_contacted', 'total_leads_finished',
               'total_conversions', 'total_leads_finished', 'total_conversions'].includes(metric.name))
            await this.leadServiceInstance
                .metrics(
                    this.actionSelected ? this.actionSelected : [],
                    filterDate[0],
                    filterDate[1],
                    metric.name,
                    this.pluginSelected ? this.pluginSelected.plugin : '' as string,
                    showFunnel,
                    this.$auth.user().id_user
                ).then((result: any) => {
                    if (metric.type === 'funnel' || metric.type === null){
                        this.$set(this.metricsUser.funnel, metric.name, {...metric, ...result})
                    } else {
                        this.$set(this.metricsUser.secondary, metric.name, {...metric, ...result})
                    }
            });


        }
      });

    if(this.$auth.user().saas && (this.$auth.user().profile == 'admin' || this.$auth.user().profile == 'platform')){
        try {
          this.topTerms = await this.saasServiceInstance.postTopTerms(
              moment(filterDate[0]).format("YYYY-MM-DD"),
              moment(filterDate[1]).format("YYYY-MM-DD"),
              this.$auth.user().id_platform
          );

          this.sentiment = await this.saasServiceInstance.getSentiment(
              moment(filterDate[0]).format("YYYY-MM-DD"),
              moment(filterDate[1]).format("YYYY-MM-DD")
          );

        } catch (error) {
            this.topTerms = false;
        }
    }

    this.loadingMetric = false;
  }

  private getActionsActive() {
    this.loadingAction = true;
    this.actionServiceInstance.indexStatus("action_active").then(
      result => {
        this.actions = result.body;
        this.loadingAction = false;
      },
      error => {
        this.loadingAction = false;
      }
    );
  }

  private getPluginByAction() {
    let filterDate: Array<any> = ["", ""];
    if (this.dateRange.startDate) {
      filterDate[0] =
        (this.$moment(this.dateRange.startDate) as any).format("YYYY-MM-DD") +
        " 00:00:00";
      filterDate[0] = this.$moment(filterDate[0], "YYYY-MM-DD HH:mm:ss");
      filterDate[0] = this.$moment
        .utc(filterDate[0])
        .format("YYYY-MM-DD HH:mm:ss");
    }

    if (this.dateRange.endDate) {
      filterDate[1] =
        (this.$moment(this.dateRange.endDate) as any).format("YYYY-MM-DD") +
        " 24:00:00";
      filterDate[1] = this.$moment(filterDate[1], "YYYY-MM-DD HH:mm:ss");
      filterDate[1] = this.$moment
        .utc(filterDate[1])
        .format("YYYY-MM-DD HH:mm:ss");
    }

    this.pluginOption = [];
    this.leadServiceInstance.getPluginByAction(
        this.actionSelected,
        filterDate[0],
        filterDate[1],
        this.$auth.user().id_platform
    ).then(async (result: any) => {
            this.pluginOption = [...result];
        }
    );
    this.loadingMetric = false;
  }

  private getSentimentPercent(sentiment: number) {
    const value =
      (sentiment * 100) /
      (this.sentiment.positive_sentiment +
        this.sentiment.neutral_sentiment +
        this.sentiment.negative_sentiment);
    return value ? parseFloat(value.toFixed(2)) + "%" : '0%';
  }

  // @Watch("dateScheduling.startDate")
  // onChangeRangeScheduling(value: any, _oldValue: any) {
  //   this.leadHistory.date_scheduling = value;
  // }

  private created() {
    // redirect case profile is not admin
    if (this.$auth.user().profile != "admin") {
      this.$router.push({ path: "/dashboard" }).catch(()=>{});
    }

    this.dateRange.startDate = this.$moment().format("YYYY/MM/DD");
    this.dateRange.endDate = this.$moment().format("YYYY/MM/DD");

    try {
      this.getMetrics();
      this.getActionsActive();
    } catch (error) {
      this.$store.commit("navBarAlert/DANGER_ALERT", `Ocorreu um erro inesperado, tente novamente em breve`);
    }
  }

  private mounted() {
    // setTimeout(() => {
    //   this.selectedPanel = this.panels[0];
    //   console.log(this.selectedPanel)
    // }, 1000);
  }
}
